const e = {
  getStatusColor: (r) => ({
    error: {
      color: "var(--color-error-default)",
      border: "1px solid var(--color-error-default)",
      "&:hover": {
        color: "var(--color-error-strong)",
        border: "1px solid var(--color-error-strong)"
      }
    },
    success: {
      color: "var(--color-accent-primary-default)",
      border: "1px solid var(--color-accent-primary-default)",
      "&:hover": {
        color: "var(--color-accent-primary-strong)",
        border: "1px solid var(--color-accent-primary-strong)"
      }
    },
    default: {
      color: "var(--color-components-input-fg-default)",
      border: "1px solid var(--color-components-input-border-default)",
      "&:hover": {
        color: "var(--color-components-input-fg-strong)",
        border: "1px solid var(--color-components-input-border-hover-default)"
      }
    }
  })[r],
  sizes: {
    sm: {
      fontSize: "1.4rem"
    },
    md: {
      fontSize: "1.4rem"
    },
    lg: {
      fontSize: "1.6rem"
    }
  }
};
export {
  e as helper
};
//# sourceMappingURL=helper.es.js.map
